import { createRouter, createWebHashHistory } from 'vue-router'
import HomePage from '../views/Home.vue'
import NotFound from '../views/NotFound.vue'
import Maintenance from '../views/Maintenance.vue'
import AboutPage from '../views/About.vue' // 导入新的 AboutPage 组件

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/about', // 新增的关于页面路由
    name: 'AboutPage',
    component: AboutPage
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: Maintenance
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router 